import Vue from "vue";
import Router from "vue-router";
import Resource from "@/view/guides/Resource.vue";


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      // redirect: "/index",//路径为/时的默认页面路由
      component: Resource
    },
    // {
    //   path: "/index",
    //   name: "index",
    //   meta: {
    //     title: "index"
    //   },
    //   component: Resource
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js